import { createSlice } from '@reduxjs/toolkit'

const initialDeviceState = {
  devicePage: 1,
  sitePage: 1,
  deviceLaneIdRedux: 0,
  deviceTypeIdRedux: 0,
  deviceCommentRedux: '',
  devicePortRedux: '',
  deviceEnableValue: '',
  deviceIdRedux: 0,
  deviceLocationData: {},
  deviceIdentifierRedux: '',
  deviceFileRedux: null,
  deviceFileListRedux: null,
}

const deviceSlice = createSlice({
  name: 'device',
  initialState: initialDeviceState,
  reducers: {
    devicePageHandler(state, action) {
      state.devicePage = action.payload
    },
    sitePageHandler(state, action) {
      state.sitePage = action.payload
    },
    deviceIdHandler(state, action) {
      state.deviceIdRedux = action.payload
    },
    deviceLaneIdHandler(state, action) {
      state.deviceLaneIdRedux = action.payload
    },
    deviceTypeIdHandler(state, action) {
      state.deviceTypeIdRedux = action.payload
    },
    deviceCommentHandler(state, action) {
      state.deviceCommentRedux = action.payload
    },
    devicePortHandler(state, action) {
      state.devicePortRedux = action.payload
    },
    deviceEnableHandler(state, action) {
      state.deviceEnableValue = action.payload
    },
    deviceLocationDataHandler(state, action) {
      state.deviceLocationData = action.payload
    },
    deviceIdentifierHandler(state, action) {
      state.deviceIdentifierRedux = action.payload
    },
    deviceFileHandler(state, action) {
      state.deviceFileRedux = action.payload
    },
    deviceFilesListHandler(state, action) {
      state.deviceFileListRedux = action.payload
    },
  },
})

export const deviceActions = deviceSlice.actions
export default deviceSlice.reducer
